import React from 'react';

import Typography from '@material-ui/core/Typography';

import Title from '../../components/Title/Title';

import useStyles from './Style';

const Cronograma = () => {
    const classes = useStyles();
    return (
        <>
            <span id="pgto"></span>

            <Title id="anchor-04" className={classes.title}>
                4. CRONOGRAMA
            </Title>

            <Typography className={classes.text} component={'div'} variant="body2">
                <span className={classes.item}>4.1</span> 
                Serão consideradas válidas apenas as inscrições efetuadas no período indicado no item 3.3 deste Regulamento e previsto no Calendário Oficial da Olimpíada de Professores da OBMEP Mirim (Anexo I).
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>4.2</span> 
                No ato da inscrição, os professores deverão ler atentamente e verificar cuidadosamente datas e prazos do Calendário Oficial da Olimpíada de Professores da OBMEP Mirim (Anexo I).
            </Typography>
            
            <Typography className={classes.text} component={'div'} variant="body2">
                <span className={classes.item}>4.3</span> 
                O <span className={classes.bolder}>IMPA</span> poderá, a seu exclusivo critério e a qualquer tempo, realizar alterações e adequações na Olimpíada de Professores da OBMEP Mirim e, por consequência, neste Regulamento, 
                incluindo mudanças no cronograma, na logística das provas e no formato da olimpíada, além da suspensão temporária ou cancelamento do concurso cultural, por exemplo, mas não exclusivamente, 
                na hipótese de limitações sanitárias impostas por pandemias ou por quaisquer ocorrências que impeçam ou restrinjam o acesso presencial de professores, aplicadores de provas e responsáveis pelos 
                centros de aplicação. Alterações e adequações serão divulgadas na página da olimpíada: <span className={classes.underline}>professores.olimpiadamirim.obmep.org.br</span>.
            </Typography>
        </>
    )
}

export default Cronograma;